import axios from 'axios';
import { algoliaApiKey, algoliaApplicationId } from '../utils/constants';

const ALGOLIA_BASE_URL = `https://${algoliaApplicationId}.algolia.net`;
const CLUB_PLACEHOLDER_LOGO_URL =
    'https://cdn.sportmonks.com/images/soccer/team_placeholder.png';

export default {
    searchClubs: async ({ query, gender, types }) => {
        const filters = [`active:1`];

        if (gender === 'MEN') {
            filters.push(`clubGender:BOTH`);
        }
        if (types) {
            const typeFilters = types.map(type => `typeOfOrg:${type}`);
            if (typeFilters.length > 1) {
                filters.push(`(${typeFilters.join(' OR ')})`);
            } else {
                filters.push(typeFilters[0]);
            }
        }

        const response = await axios.post(
            `${ALGOLIA_BASE_URL}/1/indexes/clubs/query`,
            {
                query,
                page: 0,
                hitsPerPage: 10,
                ...(filters.length && { filters: filters.join(' AND ') })
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    'x-algolia-application-id': algoliaApplicationId,
                    'x-algolia-api-key': algoliaApiKey
                }
            }
        );

        if (!response.data?.hits) {
            return [];
        }

        const formattedResults = response.data.hits.map(hit => {
            return {
                id: hit.id,
                clubName: hit.clubName,
                clubLogoUrl: hit.clubLogoUrl || CLUB_PLACEHOLDER_LOGO_URL,
                typeOfOrg: hit.typeOfOrg,
                clubGender: hit.clubGender,
                countryName: hit.countryName,
                continentName: hit.continentName
            };
        });

        return formattedResults;
    }
};
